import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isStaging(): boolean {
  if (typeof window === "undefined") {
    return process.env.IS_STAGING === "true";
  }

  if (typeof IS_STAGING !== "undefined") {
    return IS_STAGING;
  }

  return false;
}

export function withStagingAlgoliaPrefixIndex(indexName: string) {
  if (isStaging()) {
    return `staging__${indexName}`;
  }
  return indexName;
}

export function withOriginalAlgoliaIndex(indexName: string) {
  if (isStaging()) {
    return indexName.replace("staging__", "");
  }
  return indexName;
}
